/*
* Menu handling
*/

import debounce from '../components/debounce.js';

// main menu toggle

$('.js-toggle-nav.header__toggle--nav').click(function() {
    $(this).toggleClass('is-active');
    $('.header__nav').toggleClass('is-active');
    $('body').toggleClass('mobile-menu--active');
});

window.addEventListener('scroll', debounce(() => {
    headerScrolled();
}), { passive: true });

function headerScrolled() {
    if(window.scrollY > 60) {
        $('.header').addClass('is-scrolled');
    } else {
        $('.header').removeClass('is-scrolled');
    }
}

headerScrolled();
